import SEO from '../components/SEO'
import ScrollReveal from '../components/ScrollReveal'
import ContactForm from '../components/ContactForm'
import '../styles/shared-hero.css'
import './Contact.css'

function Contact() {
  return (
    <>
      <SEO 
        title="Contact" 
        description="Get in touch with Claverton 42 for fractional CTO services. No charge, just a conversation."
        path="/contact"
      />
      
      {/* Hero Section */}
      <section className="contact-hero page-hero">
        <div className="page-hero-content contact-hero-content">
          <ScrollReveal>
            <h1>Let's talk about your <em>technology</em> challenges</h1>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <p className="contact-hero-description">
              No charge, just a conversation. We aim to respond to every inquiry
              promptly, typically within one business day.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-container">
          <ScrollReveal className="contact-info">
            <h2>Get in touch</h2>
            <p>
              You can also reach us directly via email.
            </p>
            <div className="contact-methods">
              <a href="mailto:hello@claverton42.com" className="contact-method">
                <span className="contact-method-label">Email</span>
                <span className="contact-method-value">hello@claverton42.com</span>
              </a>

            </div>
          </ScrollReveal>

          <ScrollReveal className="contact-form-wrapper" delay={200}>
            <ContactForm />
          </ScrollReveal>
        </div>
      </section>
    </>
  )
}

export default Contact
